import { css } from "lit";

export const holloLiveCardStyles = css`
  .hollo-live-card {
    background: #fff;
    display: grid;
    place-items: center;
    height: 220px;
    position: relative;
  }
  @media (max-width: 460px) {
    .hollo-live-card {
      height: 30dvh;
    }
  }
  .hollo-portrait-container {
    width: 13rem;
    height: 13rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 99999px;
    overflow: hidden;
  }

  .hollo-portrait {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 99999px;
  }
  .hollo-record-btn {
    position: absolute;
    bottom: 16px;
    left: 50%;
    transform: translateX(-50%);
    width: 56px;
    height: 56px;
    border-radius: 999px;
    border: none;
    cursor: pointer;
    display: grid;
    place-items: center;
    background: #ef4444;
    color: #fff;
    box-shadow: 0 8px 22px rgba(239, 68, 68, 0.35);
  }

  .hollo-record-btn.hollo-active .hollo-stop {
    width: 16px;
    height: 16px;
    background: #fff;
    border-radius: 4px;
  }
  @keyframes pulse {
    0%,
    100% {
      opacity: 0.7;
      transform: scale(1);
    }
    50% {
      opacity: 1;
      transform: scale(1.15);
    }
  }
  .hollo-error {
    position: absolute;
    bottom: 84px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 12px;
    color: #fff;
    background: rgba(239, 68, 68, 0.9);
    padding: 4px 8px;
    border-radius: 999px;
  }
  .hollo-perm-hint {
    position: absolute;
    bottom: 84px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 12px;
    color: #111827;
    background: #fffbeb;
    border: 1px solid #fbbf24;
    padding: 6px 10px;
    border-radius: 10px;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
  }
  .hollo-mini-spinner {
    width: 36px;
    height: 36px;
    border-radius: 999px;
    border: 3px solid rgba(0, 0, 0, 0.1);
    border-top-color: #111827;
    animation: hollo-spin 1s linear infinite;
  }
  @keyframes hollo-spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  .hollo-twinfade-top {
    position: absolute;
    top: -10px;
    left: 0;
    width: 100%;
    height: 25%;
    z-index: 1;
    pointer-events: none;
    transform: scaleY(-1);
  }

  .hollo-twinfade-top svg {
    width: 100%;
    height: 100%;
  }

  .hollo-twinfade-bottom {
    position: absolute;
    bottom: -10px;
    left: 0;
    width: 100%;
    height: 25%;
    z-index: 1;
    pointer-events: none;
  }

  .hollo-twinfade-bottom svg {
    width: 100%;
    height: 100%;
  }
`;
